<div id="snapshot-widget" class="vtr-widget-snapshot">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="information">
					<div class="row title-box">
						<h2 id="snapshot-widget-title" role="heading" class="title">{{'snapshot.title' | translate}}</h2>
						<!-- This div is being used to avoid screen reader to read this content without stop -->
						<div>
							<vtr-ui-question-mark-button
								[componentId]="'snapshot-widget-tooltip-information'"
								[ariaLabel]="'snapshot-widget-information tooltip, which reads: ' + ('snapshot.informationTooltipDescription' | translate)"
								[tooltipText]="'snapshot.informationTooltipDescription' | translate"
								[tooltipId]="'snapshot-widget-information-tooltip'"
								class="question-mark-container"
							></vtr-ui-question-mark-button>
						</div>
					</div>

					<p id="snapshot-widget-description" role="text" class="description">{{'snapshot.snapshotInformation' | translate}}</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="button-row">
					<vtr-material-button
						linkId="snapshot-widget-btn"
						[label]="'snapshot.snapshotWidgetButton' | translate | uppercase"
						(buttonClick)="navigateToSnapshotPage()"
						heightSize="lg">
					</vtr-material-button>
				</div>
			</div>
		</div>
	</div>
</div>
